import head from 'lodash/head';
import fireErrorAnalytics from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';
import { performGetRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import { fireOperationalAnalytics } from '@atlassian/jira-product-analytics-bridge';
import type { Action } from '@atlassian/react-sweet-state';
import { ZOOM_ENTITY_TYPE, ZOOM_APP_TYPE } from '../../../common/constants';
import type { State, ContainerProps } from '../../types';
import type { IsZoomDisabledProps, Response } from './types';

export const isZoomConnected =
	({ connectionId, projectId }: IsZoomDisabledProps): Action<State, ContainerProps> =>
	async ({ getState, setState }, { cloudId, analyticsEvent }) => {
		const { zoomWorkspaceConnections } = getState();

		try {
			const response: Response = await performGetRequest(
				`/gateway/api/chatplatform/opsgenie/${cloudId}/api/internal-api/v3/chat/chat-connection-entity-control?connectionId=${connectionId}&entityType=${ZOOM_ENTITY_TYPE}&entityId=${projectId}&appType=${ZOOM_APP_TYPE}`,
			);
			fireOperationalAnalytics(analyticsEvent, 'isZoomConnected succeeded');
			setState({
				zoomWorkspaceConnections: {
					...zoomWorkspaceConnections,
					isConnected: response?.data?.length > 0,
					isLoading: false,
					isZoomEnabled: head(response?.data || [])?.enabled,
				},
			});
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
		} catch (error: any) {
			fireErrorAnalytics({
				meta: {
					id: 'isZoomConnected',
					packageName: 'jiraServicedeskIncidentManagementSettings',
				},
				error,
				sendToPrivacyUnsafeSplunk: true,
			});
			setState({
				zoomWorkspaceConnections: {
					...zoomWorkspaceConnections,
					error: error.message,
					isLoading: false,
					isZoomEnabled: false,
				},
			});
		}
	};
